import { useEffect } from 'react';
import { calculateLeadSource } from '../utils/leadSource';

const useSourceTracking = () => {
  useEffect(() => {
    calculateLeadSource();
  }, []);
};

export default useSourceTracking;